import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Select from "react-select";
import RestService from "./../../Restservice";
import CustomTable from "./../../component/CustomTable";
import Loader from "./../../component/Loader";
import GlobalHelmet from "./../../GlobalHelmet";
import Validate from "./../../component/Authvalidate";
import Breadcrumbs from "./../../component/breadcrumbs";
import Common from "./../../common.json";
const EditOption = React.lazy(() => import("./../../component/EditOption"));

const useStyles = makeStyles((theme) => ({
  root: {},
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  setSelect: {
    width: "100%",
    //maxWidth: "300px",
    display: "inline-block",
    marginLeft: "10px",
  },
}));

export default function MarketbreadthStock() {
  let userParams = useParams();
  let ex_sector_id = userParams.ex_sector_id ? userParams.ex_sector_id : 0;
  let mobile = "";
  let web_token = "";
  const userdata = localStorage.getItem("userdata")
    ? JSON.parse(localStorage.getItem("userdata"))
    : "";
  mobile = userdata.mobile ? userdata.mobile : "";
  web_token = userdata.web_token ? userdata.web_token : "";
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [globaldata, setglobaldata] = useState(false);
  const [sectorId, setSectorId] = useState(ex_sector_id);
  const [ntime, setntime] = useState(false);

  useEffect(() => {
    setLoading(true);
    RestService.getMarketBreadthStockData(
      function (res) {
        setLoading(false);
        const response = JSON.parse(res);
        setglobaldata(response.data.response);
      },
      mobile,
      web_token,
      sectorId
    );
  }, [ntime, mobile, web_token, sectorId]);
  const getUpdatedSector = (event) => {
    setSectorId(event.value);
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  };
  function refreshPage() {
    var d = new Date();
    var n = d.getTime();
    setntime(n);
  }
  return (
    <>
      <Validate />
      <GlobalHelmet {...Common?.MarketbreadthStock} />
      {loading ? <Loader /> : ""}
      <div className="bodycontainer">
        <div className="auto-space">
          <div className="row">
            <div className="col-sm-12">
              <Breadcrumbs
                page={
                  globaldata?.sectorName
                    ? 'Market Breadth :<span className="highlighttext">' +
                      globaldata?.sectorName +
                      "</span> "
                    : ""
                }
              />

              <div className={classes.root}>
                <div className="">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="tabelcontiner">
                        <div className="row edit-columns">
                          <div className="col-md-6">
                            <h3>
                              <span className="highlighttext">
                                {globaldata?.sectorName}
                              </span>
                            </h3>
                          </div>
                          <div className="col-md-4">
                            <Select
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                              }}
                              menuPosition={"fixed"}
                              onChange={getUpdatedSector}
                              options={
                                globaldata.getSector ? globaldata.getSector : []
                              }
                              name="symbols"
                              className={
                                classes.setSelect + " pr-2 select-option"
                              }
                              placeholder="Select Stock"
                            />
                          </div>
                          <div className="col-md-2 text-right">
                            <button
                              className="btn btn-success"
                              title="Reload Page"
                              onClick={refreshPage}
                            >
                              <i className="fa fa-refresh"></i>
                            </button>{" "}
                            &nbsp;
                            <EditOption />
                          </div>
                        </div>
                        {!globaldata.getDetails ? (
                          ""
                        ) : (
                          <>
                            <CustomTable
                              key={globaldata?.setColumn?.dataField}
                              columndata={
                                globaldata.setColumn ? globaldata.setColumn : ""
                              }
                              marketdata={
                                globaldata.getDetails
                                  ? globaldata.getDetails
                                  : ""
                              }
                              redirectlink="/stocks/"
                              pageSizeNumber="10"
                            />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
